export type CouponDiscountType = 'percentage' | 'fixed';

export const COUPON_DISCOUNT_TYPES: { value: CouponDiscountType; label: string }[] = [
    { value: 'percentage', label: 'Porcentaje' },
    { value: 'fixed', label: 'Monto fijo' }
];

/**
 * Cupón tal como lo devuelve el backend (GET).
 * NOTA: `amount` y `maxDiscountValue` viajan en NEGATIVO desde el backend
 * (misma convención que transversal.discount_rule). El servicio se encarga
 * de convertirlos a valor absoluto para mostrarlos en la UI.
 */
export interface Coupon {
    id: string;
    code: string;
    description: string;
    discountType: CouponDiscountType;
    amount: number;
    maxDiscountValue?: number;
    maxRedemptionsTotal?: number;
    maxRedemptionsPerUser: number;
    minServiceValue?: number;
    categoryId?: string;
    subcategoryId?: string;
    firstJobOnly: boolean;
    isStackable: boolean;
    /**
     * Si es `true`, el cupón se aplica SOLO (sin que el usuario digite código)
     * a todos los usuarios elegibles cuando piden el resumen de pago sin
     * código manual. Un código digitado siempre lo desplaza. El resto de
     * reglas (vigencia, cupo, mínimo, categoría, un uso por usuario, etc.)
     * siguen aplicando igual. Es un boolean plano, no aplica la convención
     * de negar el signo.
     */
    applyAutomatically: boolean;
    validFrom?: string;
    validUntil?: string;
    isActive: boolean;
    redemptionsCount?: number;
    createdAt?: string;
}

/**
 * Body para crear/editar un cupón. `amount`/`maxDiscountValue` se envían
 * en NEGATIVO (lo hace CouponService antes de llamar al backend).
 */
export interface CouponRequest {
    id?: string;
    code: string;
    description: string;
    discountType: CouponDiscountType;
    amount: number;
    maxDiscountValue?: number;
    maxRedemptionsTotal?: number;
    maxRedemptionsPerUser: number;
    minServiceValue?: number;
    categoryId?: string;
    subcategoryId?: string;
    firstJobOnly: boolean;
    isStackable: boolean;
    /** Ver detalle en `Coupon.applyAutomatically`. Boolean plano, no se niega. */
    applyAutomatically: boolean;
    validFrom?: string;
    validUntil?: string;
    isActive?: boolean;
}

export interface CouponPage {
    list: Coupon[];
    totalPages: number;
    totalElements: number;
}
